import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { MusicProvider } from './context/MusicContext';

// Import des composants
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Poems from './pages/Poems';
import Surprise from './pages/Surprise';
import Compliments from './pages/Compliments';
import BackgroundWrapper from './components/BackgroundWrapper';

// Styled components
const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <MusicProvider>
      <Router>
        <BackgroundWrapper>
          <AppContainer>
            <Header />
            <MainContent>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/poems" element={<Poems />} />
                <Route path="/surprise" element={<Surprise />} />
                <Route path="/compliments" element={<Compliments />} />
              </Routes>
            </MainContent>
            <Footer />
          </AppContainer>
        </BackgroundWrapper>
      </Router>
    </MusicProvider>
  );
}

export default App;
